import React from "react";
import PropTypes from "prop-types";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import "../styles/components/Podcast.scss";

const Podcast = ({ title, media, ctaLink }) => (
    <div className="podcast p-4 m-3">
        <GatsbyImageWithSVGSupport
            image={media}
            className="mb-3 podcast-image ratio ratio-1x1"
        />
        <h5 className="mb-3">{title}</h5>
        <a className="mt-auto" href={ctaLink}>
            Click to listen &rarr;
        </a>
    </div>
);

Podcast.propTypes = {
    title: PropTypes.string.isRequired,
    media: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        gatsbyImageData: PropTypes.object,
        file: PropTypes.shape({
            contentType: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }),
    ctaLink: PropTypes.string.isRequired,
};

export default Podcast;
